import RAF from 'raf'

const VueCollide = {
	install(Vue, options = {}) {

		let _this = this
		this.curIndex = 0
		this.elements = []

		Vue.directive('collide', {

			bind(el, binding) {

				if (!!window.MSInputMethodContext && !!document.documentMode) return // ie11

				el.style.opacity = 0
				_this.elements.push({
					el,
					callback() {
						let element = el
						let cl = binding.value || 'fadeIn'
						element.classList.add('animated', cl)
						_this.elements.splice(_this.curIndex, 1)
					}
				})
				_this.curIndex++

			},
		})

		RAF(function tick() {
			_this.update()
			RAF(tick)
		})

	},

	update() {
		for (let i = 0; i < this.elements.length; i++) {
			let element = this.elements[i]
			if (this.inViewport(element.el)) {
				element.callback()
				this.elements.splice(i, 1)
			}
		}
	},

	inViewport(el) {
		let rect = el.getBoundingClientRect()
		return !(rect.bottom < window.innerHeight / 4 || rect.right < 0 || rect.left > window.innerWidth || rect.top > window.innerHeight - window.innerHeight / 4)
	},

}

if (typeof window !== 'undefined' && window.Vue) {
	window.Vue.use(VueCollide)
}

export default VueCollide
